export default {
    videoId(url) {
        let parts = url.split(/[\/\=]/);

        return parts[parts.length -1];
    }
}